(function () {
  const baseUrl = "https://verb-web-service-1.onrender.com";

  window.rechargeApi = {
    /**
     * Update the quantity of a Recharge subscription.
     *
     * @param {Object} options
     * @param {string|number} options.subscriptionId - The Recharge subscription ID.
     * @param {number} options.quantity - New quantity to set.
     * @param {string|number} options.customerId - The customer ID (used for validation on backend).
     * @returns {Promise<Object>} Response JSON with subscription data or error.
     */
    async updateSubscriptionQuantity({ subscriptionId, quantity, customerId }) {
      try {
        if (!subscriptionId || !customerId || !quantity) {
          throw new Error("subscriptionId, quantity, and customerId are required");
        }

        const response = await fetch(
          `${baseUrl}/api/recharge/${subscriptionId}/quantity?customer_id=${customerId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ quantity }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to update subscription quantity");
        }

        return data;
      } catch (err) {
        console.error("Recharge API client error:", err);
        throw err;
      }
    },
    /**
     * Add a product to the next order (onetime purchase)
     * @param {Object} options
     * @param {string|number} options.chargeId - The charge ID for the subscription.
     * @param {string|number} options.customerId - The customer ID.
     * @param {string|number} options.productId - Product ID to add.
     * @param {string|number} options.variantId - Variant ID to add.
     * @param {number} [options.quantity=1] - Quantity to add (default 1).
     * @returns {Promise<Object>} API response JSON
     */
    async addProductToNextOrder({ chargeId, customerId, productId, variantId, quantity = 1 }) {
      try {
        if (!chargeId || !customerId || !productId || !variantId) {
          throw new Error("chargeId, customerId, productId, and variantId are required");
        }

        const response = await fetch(
          `${baseUrl}/api/recharge/charge/${chargeId}/next-order?customer_id=${customerId}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ product_id: productId, variant_id: variantId, quantity }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.error || "Failed to add product to next order");
        }

        return data;
      } catch (err) {
        console.error("Recharge API client error:", err);
        throw err;
      }
    },
    /**
     * List all charges for a customer
     * @param {Object} options
     * @param {string|number} options.customerId - The customer ID
     * @returns {Promise<Object>} Array of charges
     */
    async listCharges({ customerId }) {
      try {
        if (!customerId) throw new Error("customerId is required");

        // Add timestamp as query param
        const timestamp = encodeURIComponent(new Date().toISOString());
        const url = `${baseUrl}/api/recharge/charges?customer_id=${customerId}&timestamp=${timestamp}`;

        const response = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to fetch charges");

        return data;
      } catch (err) {
        console.error("Recharge API client error:", err);
        throw err;
      }
    },
  };
})();
